import React, { ReactNode } from "react";
import { Links } from "libs/constants";
import { useModalPopup } from "hooks/useModalPopup";
import usePlatform from "hooks/usePlatform";

export const DownloadButton = (props: {
	className?: string,
	children: ReactNode;
}) => {
	const { isMobilePlatform } = usePlatform();
	const { openDMMPopup } = useModalPopup();

	return (
		<>
			{isMobilePlatform ? (
				<a
					href={Links.Download}
					target="_blank"
					rel="noreferrer"
					className={props.className}
				>
					{props.children}
				</a>
			) : (
				<button
					className={props.className}
					onClick={openDMMPopup}
				>
					{props.children}
				</button>
			)}
		</>
	)
};
